import React, {useEffect, useState} from "react";
import {Item} from "../../../components/mobile/product";
import {getBrand} from "../../../service/biboMartService";
import {getProductByBrand, getMetaBrand} from "../../../service/myProductService";
import ReactHtmlParser from 'react-html-parser';
// import Head from "../../Head";

import './brand.css';
import { pushtracking } from "../../../service/trackingService";
import { useLocation } from "@reach/router";
const Brand =({uri, des})=>{
    var [productList, setProductList] = useState([]);
    const [loadMoreStart, setLoadMoreStart] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [totalItemProduct, setTotalItemProduct] = useState(0);
    const location = useLocation();
    const [meta, setMeta] = useState([]);
    const [showDes, setShowDes] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const loadProductOnBrand=(uri, page, pagesize)=>{
        try{
            getProductByBrand(page, pagesize,uri).then((response)=>{
            if(+response.status===200){
              // var _item =[];
              var _item_list = [];
              response.message.forEach((item)=>{
                _item_list.push({ 
                  item_id: item.sku,
                  item_name: item.name,
                  price: +item.raw
              });
              })
              setTotalItemProduct(+response.metadata?.total_item);
              setTotalPage(response.metadata.total_page);
              setProductList((prevData) => [...prevData, ...response.message]);        
              setShowAlert(true);
              window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                    'event': 'view_item_list',
                    'ecommerce': {
                        'items': _item_list
                    }
                });
                try{
                  var _sku_list = [];
                  _item_list.forEach((item)=>{
                      _sku_list.push(item?.sku);
                  });
                  pushtracking(window.localStorage.getItem('sessionId')??null,
                  window.localStorage.getItem('_id')??null,
                  window.localStorage.getItem('phone')??null ,
                  location.pathname, "Thương hiệu", 0,0,'index','inWeb',[],'Website Mobile').then((response)=>{
                      // // console.log('send tracking');
                  });
              }catch(e){console.log(e)}
            }
          });
        }catch(e){console.log(e)}
      }
      const loadBrand =()=>{
        try{
          getMetaBrand(uri).then((response)=>{
                  if(+response.status === 200){
                    if(response.message.length > 0){
                        setMeta(response.message);
                        window.localStorage.setItem('nameCategory',response.message?.name);
                    }
                }
            });
        }catch(e){console.log(e)}
    }
      useEffect(()=>{
        loadBrand();
        loadProductOnBrand(uri,0,16)
        localStorage.removeItem("itemCateName");
        localStorage.removeItem("itemUriBrand");
      },[]);

      const productListLoadMore = (e) => {
        const newStart = loadMoreStart + 1;
        if(totalPage >= newStart){
          setLoadMoreStart(newStart);
          loadProductOnBrand(uri,newStart, 16);
        }
      };
      const InfiniteScroll = ({ loadMore }) => {
        useEffect(() => {
          const handleScroll = () => {
            var check = Math.abs(parseInt(window.innerHeight +document.documentElement.scrollTop) - parseInt(document.documentElement.offsetHeight)) 
            if (check === 0 || check === 1){
              loadMore();
           }
            const scrollPosition = window.scrollY;
            setIsVisible(scrollPosition > 100);
          };
      
          window.addEventListener("scroll", handleScroll);
          return () => {
            window.removeEventListener("scroll", handleScroll);
          };
        }, [loadMore]);
      
        return null;
    };
    const toggleShowMore = () => {
        setShowDes(!showDes);
        // if(showDes){
        // window.scrollTo(0,700)
        // }
    }
    const [isVisible, setIsVisible] = useState(false);
    const scrollToTop = () => {
      window.scrollTo({
          top: 0,
          behavior: 'smooth', // Cuộn mềm mại
      });
  };
    return(
      <>
      {/* <Head key="Head" item={meta}/> */}
      {/* <h1 className="d-none">{window.localStorage.getItem('nameCategory')}</h1> */}
        <div className="row mgt-10">
            <ul className="row col-ul-1">
                {
                    productList?.length > 0 ? 
                    (
                        productList?.map((item, j)=>{
                            return <Item item={item} index={item?.sku+j}/>
                        })
                    )
                    :
                    (showAlert === true && productList?.length <= 0 ?(
                      <div className='message pdl-20 pdr-20'>
                          <div className='info'>
                          <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i> <span>Không có sản phẩm phù hợp.</span>
                          </div>
                          
                      </div>
                  ):(null))
                }  
            </ul>
            <InfiniteScroll loadMore={productListLoadMore} />
            {
                +totalItemProduct > 10 &&  +totalItemProduct - +productList?.length > 0 ?(
                    <div className="loading-page-app-item pdy-5" style={{textAlign:"center"}}> <img src="/../images/loading.gif" alt="icon"/></div>
                ):(null)
            }

            <div id="detail-catalog-mobile" className="col-12 pdx-24 infor-product-text mgt-10">
                <div className="description">
                {showDes ? ReactHtmlParser(des) : ReactHtmlParser(des?.substring(0, 600))}
                </div>
                {des?.length > 600 && (
                   <div className="col-12 mgt-10 mgb-25 in-f">
                      <button className="container-show-button in-f" onClick={toggleShowMore}>
                          <a><i className={showDes ? "fa fa-angle-up pdr-5" : "fa fa-angle-down pdr-5"}></i>{showDes ? "THU NHỎ" : "XEM THÊM"}</a>
                      </button>
                  </div>
                )}
            </div>
            
        </div>  
        <div className="group-icon-bottom-right">
        <div className={`mgt-10 ${isVisible ? 'visible' : 'd-none'}`} onClick={scrollToTop}>
            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/icontotop.png" alt="icon"></img>
        </div>
      </div> 
      </>
    );
}
export default Brand